/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioSpeakerIcon24Regular = forwardRef('MediaAudioSpeakerIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 14a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4.5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" }),
        React.createElement("path", { d: "M12 8a1.25 1.25 0 1 0 0-2.5A1.25 1.25 0 0 0 12 8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 6A3.75 3.75 0 0 1 8 2.25h8A3.75 3.75 0 0 1 19.75 6v12A3.75 3.75 0 0 1 16 21.75H8A3.75 3.75 0 0 1 4.25 18V6ZM8 3.75A2.25 2.25 0 0 0 5.75 6v12A2.25 2.25 0 0 0 8 20.25h8A2.25 2.25 0 0 0 18.25 18V6A2.25 2.25 0 0 0 16 3.75H8Z" })));
});
